import MoreInfoContent from './MoreInfoContent'

export default MoreInfoContent
